/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  ZoomControl,
  Tooltip,
  Rectangle,
  Circle,
} from 'react-leaflet';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { SearchBar } from './fragments';
import { blueMarker, redMarker, circleMarker } from './fragments/mapIcon';
import { checkCoordsAvailable } from '../../../utils/mapFunctions';
import {
  DirectForLine,
  TrafficStatus,
  CircleRangeInput,
  LoadingTrafficStatus,
  MapRefComponent,
  ResetPositionChoose,
  TrafficStatusForPositionChoose,
} from './fragments';
import { StyledWrapper } from './Map.styled';
import { isEmpty } from '../../../utils/functions';
import { enqueueSnackbar } from '../../../features/notificationSlice';
import {
  getTrafficStatusRectangle,
  getTrafficStatusCircle,
} from '../../../features/trafficStatusMapSlice';

const Map = (props) => {
  const dispatch = useDispatch();
  const [center, setCenter] = useState([10.7725104, 106.6575988]);
  const [searchResult, setSearchResult] = useState({});
  const [startMarkerPosition, setStartMarkerPosition] = useState({});
  const [endMarkerPosition, setEndMarkerPosition] = useState({});

  const [lineOption, setLineOption] = useState(0);
  const rectangleRef = useRef(null);

  const {
    setMapDataPosition,
    positionChoose,
    radius,
    setRadius,
    setOption,
    isDisplayTrafficStatus,
  } = props;
  const { t } = useTranslation();
  const [currentZoomLevel, setCurrentZoomLevel] = useState(16);
  const [currentBounds, setCurrentBounds] = useState({});

  useEffect(() => {
    setOption(lineOption);
  }, [lineOption]);
  // when update position of 2 marker
  useEffect(() => {
    // check if position choose is circle
    if (positionChoose === 'circle') {
      if (startMarkerPosition.lat) {
        const centerPoint = [startMarkerPosition.lat, startMarkerPosition.lng];
        const payloadCircle = { radius_in_meter: radius, center: centerPoint };
        dispatch(getTrafficStatusCircle(payloadCircle));
        setMapDataPosition([centerPoint]); // position to send request
      } else {
        setMapDataPosition([]);
      }
      return;
    }
    //  position choose is rectangle or line
    if (startMarkerPosition.lat && endMarkerPosition.lat) {
      const startPoint = [startMarkerPosition.lat, startMarkerPosition.lng];
      const endPoint = [endMarkerPosition.lat, endMarkerPosition.lng];
      if (positionChoose === 'line') {
        setMapDataPosition([startPoint, endPoint]); // position to send request
      } else if (positionChoose === 'rectangle') {
        if (rectangleRef.current) {
          const latlngs = rectangleRef.current._latlngs[0];
          const rectangleCoordinates = latlngs.map((item) => [
            item.lat,
            item.lng,
          ]);
          const { _northEast, _southWest } = rectangleRef.current._bounds;
          const payloadRectangle = {
            NElat: _northEast.lat,
            NElng: _northEast.lng,
            WSlat: _southWest.lat,
            WSlng: _southWest.lng,
          };
          dispatch(getTrafficStatusRectangle(payloadRectangle));
          setMapDataPosition(rectangleCoordinates);
        }
      }
    } else {
      setMapDataPosition([]);
    }
  }, [startMarkerPosition, endMarkerPosition, radius]);

  // delete marker when change position choose or change mode
  useEffect(() => {
    setStartMarkerPosition({});
    setEndMarkerPosition({});
  }, [positionChoose]);

  useEffect(() => {
    setStartMarkerPosition({});
    setEndMarkerPosition({});
  }, [isDisplayTrafficStatus]);
  const handleSearchResult = (item) => {
    setSearchResult(item);
  };
  const handleAddMarker = async (position) => {
    try {
      const { lat, lng } = position;
      //disable add marker when position line or rectangle
      if (
        (positionChoose === 'line' || positionChoose === 'rectangle') &&
        !isEmpty(startMarkerPosition) &&
        !isEmpty(endMarkerPosition)
      ) {
        return;
      }
      const checked = await checkCoordsAvailable(position);
      if (!checked) {
        dispatch(
          enqueueSnackbar({
            message: t('ErrorCoordsNotAvailable'),
            options: {
              variant: 'error',
            },
          })
        );
      } else {
        // check if position choose is circle
        if (positionChoose === 'circle') {
          setStartMarkerPosition({ lat, lng });
          return;
        }
        //  position choose is rectangle or line
        if (startMarkerPosition.lat && !endMarkerPosition.lat) {
          setEndMarkerPosition({ lat, lng });
        } else {
          setStartMarkerPosition({ lat, lng });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleDragendStartMarker = async (e) => {
    try {
      const { lat, lng } = e.target['_latlng'];
      const checked = await checkCoordsAvailable(e.target['_latlng']);
      if (!checked) {
        dispatch(
          enqueueSnackbar({
            message: t('ErrorCoordsNotAvailable'),
            options: {
              variant: 'error',
            },
          })
        );
        setStartMarkerPosition({});
        setEndMarkerPosition({});
      } else {
        setStartMarkerPosition({ lat, lng });
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleDragendEndMarker = async (e) => {
    try {
      const { lat, lng } = e.target['_latlng'];
      const checked = await checkCoordsAvailable(e.target['_latlng']);
      if (!checked) {
        dispatch(
          enqueueSnackbar({
            message: t('ErrorCoordsNotAvailable'),
            options: {
              variant: 'error',
            },
          })
        );
        setStartMarkerPosition({});
        setEndMarkerPosition({});
      } else {
        setEndMarkerPosition({ lat, lng });
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <StyledWrapper>
        <SearchBar handleSearchResult={handleSearchResult} />
        <div style={{ position: 'relative' }}>
          {positionChoose === 'circle' && radius && startMarkerPosition.lat && (
            <CircleRangeInput radius={radius} setRadius={setRadius} />
          )}
          {(startMarkerPosition.lat || endMarkerPosition.lat) && (
            <ResetPositionChoose
              setStartMarkerPosition={setStartMarkerPosition}
              setEndMarkerPosition={setEndMarkerPosition}
            />
          )}
          <LoadingTrafficStatus />
          <MapContainer
            center={center}
            zoom={16}
            scrollWheelZoom={false}
            minZoom={14}
            zoomControl={false}
          >
            <TileLayer url='https://mt3.google.com/vt/lyrs=m&x={x}&y={y}&z={z}' />
            <ZoomControl position='bottomright' />
            <MapRefComponent
              setCenter={setCenter}
              searchResult={searchResult}
              handleAddMarker={handleAddMarker}
              setEndMarkerPosition={setEndMarkerPosition}
              setStartMarkerPosition={setStartMarkerPosition}
              // setCurrentCenter={setCurrentCenter}
              setCurrentZoomLevel={setCurrentZoomLevel}
              isDisplayTrafficStatus={isDisplayTrafficStatus}
              setCurrentBounds={setCurrentBounds}
            />
            {isDisplayTrafficStatus && (
              <TrafficStatus
                zoomLevel={currentZoomLevel}
                // center={currentCenter}
                bounds={currentBounds}
              />
            )}
            {!isDisplayTrafficStatus &&
              startMarkerPosition.lat &&
              endMarkerPosition.lat &&
              positionChoose === 'rectangle' && (
                <TrafficStatusForPositionChoose
                  zoomLevel={currentZoomLevel}
                  type='rectangle'
                />
              )}
              {!isDisplayTrafficStatus &&
              startMarkerPosition.lat &&
              positionChoose === 'circle' && (
                <TrafficStatusForPositionChoose
                  zoomLevel={currentZoomLevel}
                  type='circle'
                />
              )}

            {startMarkerPosition.lat && startMarkerPosition.lng && (
              <Marker
                position={[startMarkerPosition.lat, startMarkerPosition.lng]}
                icon={blueMarker}
                draggable={true}
                eventHandlers={{
                  dragend: handleDragendStartMarker,
                }}
              >
                <Tooltip>{t('StartMarker')}</Tooltip>
              </Marker>
            )}
            {endMarkerPosition.lat && endMarkerPosition.lng && (
              <Marker
                position={[endMarkerPosition.lat, endMarkerPosition.lng]}
                icon={redMarker}
                draggable={true}
                eventHandlers={{
                  dragend: handleDragendEndMarker,
                }}
              >
                <Tooltip>{t('EndMarker')}</Tooltip>
              </Marker>
            )}
            {startMarkerPosition.lat &&
              endMarkerPosition.lat &&
              positionChoose === 'rectangle' && (
                <Rectangle
                  bounds={[
                    [startMarkerPosition.lat, startMarkerPosition.lng],
                    [endMarkerPosition.lat, endMarkerPosition.lng],
                  ]}
                  pathOptions={{ color: '#000' }}
                  ref={rectangleRef}
                  eventHandlers={{
                    click: () => {
                      console.log('rectangle click');
                    },
                  }}
                />
              )}
            {startMarkerPosition.lat &&
              endMarkerPosition.lat &&
              positionChoose === 'line' && (
                <DirectForLine
                  startPoint={startMarkerPosition}
                  endPoint={endMarkerPosition}
                  option={lineOption}
                  setOption={setLineOption}
                />
              )}
            {startMarkerPosition.lat > 0 &&
              positionChoose === 'circle' &&
              radius && (
                <Circle
                  center={[startMarkerPosition.lat, startMarkerPosition.lng]}
                  radius={radius}
                  pathOptions={{ color: '#000' }}
                  eventHandlers={{
                    click: () => {
                      console.log('circle click');
                    },
                  }}
                />
              )}
            <Marker position={center} icon={circleMarker}>
              <Popup>{t('YouAreHere')}</Popup>
            </Marker>
          </MapContainer>
        </div>
      </StyledWrapper>
    </>
  );
};
export default Map;
